module.exports = __webpack_public_path__ + "img/a2.b504d7df.png";